import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHashtag } from '@fortawesome/free-solid-svg-icons';
import { NumericTextBox } from '@progress/kendo-react-inputs';
import type { FieldTypeDefinition, FieldRendererProps } from '../registry';

function NumberRenderer({ field, value, onChange, readOnly }: FieldRendererProps) {
  return (
    <NumericTextBox
      value={typeof value === 'number' ? value : null}
      onChange={(e) => onChange(e.value ?? null)}
      disabled={readOnly}
      min={field.validation?.min}
      max={field.validation?.max}
      placeholder={field.label}
    />
  );
}

export const definition: FieldTypeDefinition = {
  key: 'NUM',
  label: 'Number',
  category: 'input',
  icon: <FontAwesomeIcon icon={faHashtag} fixedWidth />,
  defaultProps: { label: 'New number field', isRequired: false },
  Renderer: NumberRenderer,
};
